/**
 * 比价列表path
 */
export const PRICE_COMPARE_LIST_PAGE_PATH = '/priceCompare/list'
